/**
 * Per-attempt client token for checkout de-duplication (999.5282, mirroring
 * David's 999.4742 ruling for the sibling /api/checkout POST endpoint). The
 * FRONTEND mints this ONCE when the checkout form renders (CheckoutPage uses
 * it as a `useState` lazy initializer, so it survives re-renders but not
 * re-mounts) and resends the SAME value on every retry of that one attempt —
 * a double-click, or a network retry of the same in-flight submit.
 *
 * A page REFRESH is NOT covered, deliberately: it remounts CheckoutPage, which
 * calls this again for a NEW token, so it starts a new attempt (David's
 * 999.4742 ruling — a genuinely new visit must not dedupe against an old one).
 * CheckoutPage also re-mints on a terminally FAILED order, so its retry CTA
 * behaves like that reload rather than replaying a dead instance.
 *
 * See checkout.controller.js's ATTEMPT_TOKEN_RE header comment for the full
 * trust-boundary reasoning on the backend side. This token is NOT a security
 * credential — its only protective value comes from being combined
 * server-side with the AUTHENTICATED, trusted userId, not from being
 * unguessable — so a plain Math.random()-based RFC4122-shaped v4 UUID is
 * sufficient. Deliberately NOT using the Web Crypto API (`crypto.randomUUID`):
 * it is unavailable in this repo's CRA/jsdom test environment (verified
 * empirically, 999.5282 — `window.crypto` is `undefined` under
 * jest-environment-jsdom@27) and would crash every test that renders
 * CheckoutPage.
 */
export function generateAttemptToken() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
